"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DutyFreeSpace = void 0;
const GlobalEventName_1 = require("../GlobalEventName");
const PartyName_1 = require("../../parties/PartyName");
const Resources_1 = require("../../../Resources");
const ResourceType_1 = require("../../../ResourceType");
class DutyFreeSpace {
    constructor() {
        this.name = GlobalEventName_1.GlobalEventName.DUTY_FREE_SPACE;
        this.description = 'Gain 2 M€ for each card with at least one floater on it (max 5) and influence.';
        this.revealedDelegate = PartyName_1.PartyName.SPOME;
        this.currentDelegate = PartyName_1.PartyName.BUREAUCRATS;
    }
    resolve(game, turmoil) {
        game.getPlayers().forEach((player) => {
            const floaterCardsWithResourcesCount = player.playedCards.filter((card) => card.resourceType === ResourceType_1.ResourceType.FLOATER
                && card.resourceCount !== undefined
                && card.resourceCount > 0).length;
            const amount = Math.min(floaterCardsWithResourcesCount, 5) + turmoil.getPlayerInfluence(player);
            player.addResource(Resources_1.Resources.MEGACREDITS, amount * 2, { log: true });
        });
    }
}
exports.DutyFreeSpace = DutyFreeSpace;
//# sourceMappingURL=DutyFreeSpace.js.map